import {clearSkillPathCache} from '../SkillPath/hooks/useStudentSkillPath';
import isWelcomeRoute from '../isWelcomeRoute';
import useClassroomInvitations from '../ClassroomInvitations/hooks/useClassroomInvitations';
import useClassrooms from '../Sidebar/hooks/useClassrooms';
import useCurrentTab from './useCurrentTab';
import useIndependentPracticeSubjects, {
  invalidateIndependentPracticeSubjectsCache
} from '../IndependentPractice/hooks/useIndependentPracticeSubjects';
import useSyncDefaultRoute from './useSyncDefaultRoute';

export default function useOnClassroomEnrollment() {
  const {pathname} = window.location;

  const currentTab = useCurrentTab();
  const {fetchClassroomInvitations} = useClassroomInvitations();
  const {fetchClassrooms} = useClassrooms();
  const {fetchIndependentPracticeSubjects} = useIndependentPracticeSubjects();
  const {syncDefaultRoute} = useSyncDefaultRoute();

  function onClassroomEnrollment(classroomId: string | undefined) {
    clearSkillPathCache();
    // Enrollment changes which subjects the student can access, so drop every cached
    // practice-subject list — the scope-less "all subjects" one and each classroom scope.
    invalidateIndependentPracticeSubjectsCache();
    fetchClassroomInvitations();
    fetchClassrooms();

    if (currentTab === 'independent-practice') {
      fetchIndependentPracticeSubjects(classroomId);
    }

    syncDefaultRoute(classroomId, pathname, !isWelcomeRoute(pathname));
  }

  return onClassroomEnrollment;
}
